<!-- 预览列表 -->
<template>
<div class="">      
    <el-table border :data="tableData" style="width: 100%;" v-loading="loading">
        <el-table-column  prop="title"  label="赛事主题"  width="220" align="center">
            <template slot-scope="scope">
            <router-link :to="{path: 'publishPreview', query: { id: scope.row.serial }}" 
                class="pub-link">{{ scope.row.title }}</router-link>
            </template>
        </el-table-column>
        <el-table-column  prop="amount"   label="参赛人数" width="120" align="center"/>
        <el-table-column  prop="address"  label="赛事地点"  align="center"/>
        <el-table-column  prop="status"  label="状态" width="120" align="center">
            <template  slot-scope="scope">
                <el-tag>{{ scope.row.status }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column  prop="eventEndDate" label="赛事日期"  width="160" align="center"/>
        <el-table-column  label="操作" fixed="right"  width="160">
            <template slot-scope="scope"> 
                <div class="action-buttons">   
                    <el-tooltip content="编辑" placement="top">
                        <i class="el-icon-edit action-icon" @click="handleUpdate(scope.row)"></i>
                    </el-tooltip>  
                    <el-tooltip content="复制链接" placement="top">
                        <i class="el-icon-link" @click="copyApplyLink(scope.row.applyUrl)"></i>
                    </el-tooltip>       
                    <el-tooltip content="正式发布" placement="top">
                        <i class="el-icon-circle-check action-icon" @click="handleAudit(scope.row,2)"></i>
                    </el-tooltip>
                    <el-tooltip content="取消发布" placement="top">
                        <i class="el-icon-circle-close action-icon" @click="handleAudit(scope.row,3)"></i>
                    </el-tooltip>
                    <el-dropdown class="more-actions" trigger="click" @command="handleMoreAction">
                        <span class="el-dropdown-link">
                            <i class="el-icon-more action-icon"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{action: 'copy', data: scope.row}" >
                                <i class="el-icon-document-copy"></i>复制
                            </el-dropdown-item>
                            <el-dropdown-item divided :command="{action: 'delete', data: scope.row}" 
                                v-if="scope.row.limitDelete">
                                <i class="el-icon-delete" style="color: #f56c6c;"></i> 
                                <span style="color: #f56c6c;">删除</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>    
                </div>
            </template>
            <!-- <template slot-scope="scope">
                <el-button type="text"  id="btn" size="small"
                        data-clipboard-action="copy" data-clipboard-target="#btn"        
                        @click="copyApplyLink(scope.row.applyUrl)">复制链接</el-button>
                <el-button @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="handleAudit(scope.row,2)" type="text" size="small">正式发布</el-button> 
                <el-button @click="handleAudit(scope.row,3)" type="text" size="small">取消发布</el-button>                        
                <el-button @click="handleDelete(scope.row)" type="text" size="small"
                    v-if="scope.row.limitDelete"
                    >删除</el-button>
                <el-button @click="handleCopy(scope.row)" type="text" size="small">复制</el-button>
            </template>                    -->
        </el-table-column>
    </el-table>
    <pagination
        style="text-align:right"
        v-show="total > 10"
        :total="total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pagesize"
        @pagination="initData"
    />
</div>
</template>
    
<script>
import pagination  from '@/components/Pagination'
import PageBack from '@/components/PageHeader'
export default {
    components:{
        pagination,
        PageBack
    },
    data() {
        return {
            loading: false,
            searchForm:{
                dateRange: '',
                status: null
            },
            startDate:'',
            endDate:'',
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            statusOption:[
                {label:'赛事报名中', value:1},
                {label:'赛事完成', value:0},
                {label:'赛事中', value:3},
                {label:'赛事取消', value:77},
            ],
        }   
    },
    created() {
        
    },
    mounted() {
        this.initData()
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        userId(){
            return localStorage.getItem('playerNo')
        },
        roles(){
            return localStorage.getItem('roles')
        }    
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.PublishAllCode,
                i_serial_mark: '',
                c_status: 66,
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.loading = true
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.total = res.Data.SumCount

                    this.tableData = result.map(item=>{
                    let startDate = this.$help.formatDate(item['报名开始日期'])
                    let endDate = this.$help.formatDate(item['报名截止日期'])
                    let startTime = this.$help.formatTime(item['报名开始时间'])
                    let endTime = this.$help.formatTime(item['报名截止时间'])

                    return{
                        index: item['序号'],
                        serial: item['标识'],
                        userId:item['发布人'],
                        title: item['主题'],
                        status: item['状态'],
                        limit: this.getRoleAuditLimit(item['状态'],item['发布人']),
                        limitDelete: this.getRoleDeleteLimit(item['发布人']),
                        type:  (item['类型']).includes('单人')? 1 : 2,
                        amount: item['参赛人数'],
                        address: item['赛事地点省份'] +''+ item['赛事地点市'] +''+item['赛事地点'],
                        sponsor: item['赞助'],
                        award: item['奖励设置'],
                        eventFlow: item['赛事流程'],
                        notice: item['报名须知'],
                        rules:item['竞赛规则'],
                        letter: item['参赛承诺'],
                        applyStartDate: startDate,
                        applyEndDate: endDate,
                        applyStartEnd: startDate +'~'+ endDate,
                        eventStartDate: item['赛事开始日期'],
                        eventEndDate: item['赛事结束日期'],
                        applyUrl: window.location.origin +'/#/publishPreview?id='+item['标识']
                    }               
                }) 
                this.loading = false
                
            }
        })            
    },
    handleLook(row){
        this.$router.push({
            path: 'publishPreview',
            query: {
                id: row.serial
            }
        })
    },
    handleUpdate(row){
        this.$router.push({
            path: 'updatePreview',
            query: {
                id: row.serial
            }
        })
    }, 
    //复制一个比赛
    handleCopy(row,type){
        this.$router.push({
            path: 'publish',
            query: {
                id: row.serial,
                type:type
            }
        })
    },  
    selectDate(d){
        this.startDate = d[0].replace(/\-/g,'')
        this.endDate = d[1].replace(/\-/g,'')
    },
    searchQuery() {
        this.initData()
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
        this.startDate = 0
        this.endDate = 0
    },
    handleSetting(row){
        localStorage.setItem('tabs','a')
        this.$router.push({
            path: '/pubSetting',
            query: {
                id: row.serial,
                type: row.type
            },

        })
    },
    getRoleAuditLimit(status,userId){
        if(status === '赛事报名中'){
            if(this.roles === '管理员'){
                return true
            }else if(this.roles === '裁判'){
                if(this.userId.toString() === userId.toString()){
                    return true
                }else{
                    return false
                }
            }
        }else{
            return false
        }
    },
    getRoleDeleteLimit(userId){        
        if(this.roles === '管理员'){
            return true
        }else if(this.roles === '裁判'){
            if(this.userId.toString() === userId.toString()){
                return true
            }else{
                return false
            }
        }else{
            return false
        }
    },
    handleAudit(row,flag){    
        let status = flag === 2 ? '正式发布' : '取消发布'        
        this.$confirm(`确定${status}吗？`,'赛事发布确认').then(res=>{
            this.confirmAudit(row,flag)
        }).catch(err=>{
            // console.log("取消")
        })            
    },
    confirmAudit(row,flag){
        // 1:查看待审核，2：审核通过，3：审核拒绝
        let params = {
            opcode: this.$code.GamePubAudit,
            i_serial_mark: row.serial,
            i_falg: flag
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                this.initData()
                this.$message.success("审核成功！")
            }else{
                this.$message.error(res.Message)
            }
        })
    },
    handleDelete(row){
        this.$confirm('删除后将不能查看预览赛事和相关信息','确定删除预览赛事吗？').then(res=>{
            let params = {
                opcode: this.$code.PublishDelete,
                i_serial_mark: row.serial
            }
            this.$api.requestAPI(params).then(data=>{
                if(data.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()
                }else{
                    this.$message.error(data.Message)
                }
            })
        }).catch(err=>{
            console.log(err)
        })
    }, 
    copyApplyLink(url){
        var input = document.createElement("input"); // 创建input对象
        input.value = url; // 设置复制内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        this.$message.success('复制链接成功：'+ input.value)
    },
     //复制一个比赛
     handleCopy(row){
        this.$router.push({
            path: 'updatePreview',
            query: {
                id: row.serial,
                type: 'copy'
            }
        })
    },  
    handleMoreAction(command){
        const { action, data } = command;          
          switch(action) {
            case 'copy':
                this.handleCopy(data)
              break;
            case 'delete':
                this.handleDelete(data)

              break;
          }
    }
}
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.pub-link{
    text-decoration: underline;
    color: red
}
 .action-buttons {
    display: flex;
    gap: 8px;
}
.action-icon {
    font-size: 16px;
    cursor: pointer;
    color: #606266;
    transition: color 0.3s;
}
.action-icon:hover {
    color: #409eff;
}
.action-icon.delete:hover {
    color: #f56c6c;
}
.more-actions {
    margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/components/previewTab.vue